<section class="img-container text-center img-fluid my-5">
    <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="logo" class="mx-auto d-block"
        class="width-50-max-500">
    <div class="centered my-5">
        <h1>{{ 'FLYGETS.FAQ.TITLE' | transloco }}</h1>
        <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{ 'CONTACT.BACK' | transloco |
            uppercase}}</button>
    </div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ1.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ1.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ1.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ2.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ2.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ2.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ3.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ3.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ3.ANSWER2' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ3.ANSWER3' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ3.ANSWER4' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ4.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ4.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ4.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ5.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ5.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ5.ANSWER2' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ5.ANSWER3' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ5.ANSWER4' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ6.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ6.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ6.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ7.QUESTION' | transloco }}</h2>
    <p class="lead">
        {{ 'FLYGETS.FAQ.FAQ7.ANSWER1_1' | transloco }}
        <a (click)="openConsent()" class="link-blue-underline-pointer">{{
            'FLYGETS.FAQ.FAQ7.ANSWER1_2' | transloco }}</a>
        {{ 'FLYGETS.FAQ.FAQ7.ANSWER1_3' | transloco }}
        <a href="mailto:dataskyddsombud@matchedin.se"
            class="link-blue-underline">dataskyddsombud&#64;matchedin.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ8.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ8.ANSWER1' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ9.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ9.ANSWER1' | transloco"></div>
    <p class="lead"><a [routerLink]="['/self-service']" class="link-blue-underline">{{
            'FLYGETS.FAQ.FAQ9.ANSWER2' | transloco }} </a></p>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ9.ANSWER3' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ9.ANSWER4' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ10.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ10.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ10.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ11.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ11.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ11.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ12.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ12.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ12.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ13.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ13.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ13.ANSWER2' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ13.ANSWER3' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ14.QUESTION' | transloco }}</h2>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ14.ANSWER1' | transloco"></div>
    <div class="lead mb-2" [innerHTML]="'FLYGETS.FAQ.FAQ14.ANSWER2' | transloco"></div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>{{ 'FLYGETS.FAQ.FAQ15.QUESTION' | transloco }}</h2>
    <p class="lead">
        {{ 'FLYGETS.FAQ.FAQ15.ANSWER1' | transloco }}
    </p>
</section>


<div class="jumbotron jumbotron-fluid mt-4">
    <div class="container">
        <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{ 'CONTACT.BACK' | transloco |
            uppercase}}</button>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT1' | transloco }}</p>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
        <a [routerLink]="['/flygets/kontakta-oss']" class="link-blue-underline">{{
            'FLYGETS.CONTACT.FORM' | transloco }}</a><br>
        <a href="mailto:info@flygets.se" class="link-blue-underline">info&#64;flygets.se</a><br>
        <a href="tel: 010-330 03 33"> 010-330 03 33</a>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
    </div>
</div>


<app-small-footer></app-small-footer>